import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import PageLayout from 'components/layouts/PageLayout';
import SectionLayout from 'components/layouts/SectionLayout';
import BigBanner from 'components/BigBanner';
import CallToActionPHI from 'components/CallToActionPHI';
import StatesCollapse from 'components/StatesCollapse';
import Carriers from 'components/Carriers';
import Carousel from 'components/Carousel';
import FAQsSection from 'components/FAQsSection';

import { homeBannerContent } from './content/homeBannerContent';
import TenthSection from './content/TenthSection';
import ThirdSection from './content/ThirdSection';
import FourthSection from './content/FourthSection';
import SixthSection from './content/SixthSection';
import SeventhSection from './content/SeventhSection';
import EighthSection from './content/EighthSection';
import NinthSection from './content/NinthSection';
import FirstSection from './content/FirstSection';

function Home() {
  const navigate = useNavigate();

  useEffect(() => {
    // Change Tab Title
    document.title = "Insurance Enterprise";

    // Auto-redirect to Lump Sum Benefits Calculator if visitor clicked the email marketing link
    if (typeof window !== 'undefined' && window.location.search) {
      const searchParams = new URLSearchParams(window.location.search);
      const utmSource = (searchParams.get('utm_source') || '').toLowerCase();
      const utmMedium = (searchParams.get('utm_medium') || '').toLowerCase();
      const utmCampaign = (searchParams.get('utm_campaign') || '').toLowerCase();
      const source = (searchParams.get('source') || '').toLowerCase();

      const hasLumpSumParam =
        searchParams.has('dob') ||
        searchParams.has('dateOfBirth') ||
        searchParams.has('coverage') ||
        searchParams.has('coverageAmount') ||
        searchParams.has('ref') ||
        searchParams.has('refId') ||
        searchParams.has('referenceId');

      const isFromEmailCampaign =
        utmSource.includes('email') ||
        utmMedium.includes('email') ||
        source.includes('email') ||
        utmCampaign.includes('lump') ||
        utmCampaign.includes('benefit') ||
        utmCampaign.includes('cancer') ||
        hasLumpSumParam;

      if (isFromEmailCampaign) {
        navigate('/calculators/lump-sum-benefits' + window.location.search, { replace: true });
      }
    }
  }, [navigate]);

  return (
    <>

      <BigBanner content={homeBannerContent} />
      <PageLayout
        content={
          <>
            <SectionLayout content={<FirstSection />} />
            <SectionLayout content={<>
              <div className='flex flex-col md:flex-row gap-10'>
                <div className='w-full'>
                  <div className='font-bold text-xl mb-4'>Overview of our Gold Plan</div>
                  <iframe className='w-full border' height="315" src="https://www.youtube-nocookie.com/embed/9MtrC2xVAtM?si=Per13JBrppq3_TgL" title="GOLD" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; web-share" referrerpolicy="strict-origin-when-cross-origin"></iframe>
                </div>
                <div className='w-full'>
                  <div className='font-bold text-xl mb-4'>Overview of our Silver Plan</div>
                  <iframe className='w-full border' height="315" src="https://www.youtube-nocookie.com/embed/YPoFAjgSwx0?si=jHGGyjx4COmpFGPf" title="SILVER" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; web-share" referrerpolicy="strict-origin-when-cross-origin"></iframe>
                </div>
              </div>
            </>} />
            <SectionLayout content={<Carousel />} background='bg-slate-200' />
            <SectionLayout content={<ThirdSection />} />
            <SectionLayout content={<FourthSection />} />
            <SectionLayout content={<Carriers />} />
            <SectionLayout content={<SixthSection />} />
            <SectionLayout content={<SeventhSection />} background='bg-slate-200' />
            <SectionLayout content={<EighthSection />} />
            <SectionLayout content={<NinthSection />} />
            <SectionLayout content={<TenthSection />} background='bg-secondary' />
            <SectionLayout content={<StatesCollapse />} background='bg-[#F5ECEC]' />
            <SectionLayout content={<FAQsSection />} background='bg-blurred-banner backdrop-brightness-200 bg-cover bg-center bg-no-repeat' />
            <SectionLayout content={<CallToActionPHI />} />
          </>
        }
      />
    </>
  );
}

export default Home;